import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Beacon } from "../types/models/Beacon";
import { BanUser, RemoveBeacon } from "../redux/actions/Moderation";
import { useAppDispatch } from "../utils/hooks";

export const ModerationActions = ["REMOVE", "BAN"] as const;

export interface ConfirmModerationDialogProps {
  open: boolean;
  toggleOpen: Function;
  action: (typeof ModerationActions)[number];
  beacon: Beacon;
}

function ConfirmModerationDialog(props: ConfirmModerationDialogProps) {
  // Util & Reducer
  const dispatch = useAppDispatch();

  // State

  // Functions
  function handleClose() {
    props.toggleOpen();
  }

  function handleConfirm() {
    switch (props.action) {
      case "BAN":
        handleUserBan();
        break;
      case "REMOVE":
        handleBeaconDelete();
        break;
    }
  }

  function handleUserBan() {
    dispatch(
      BanUser(props.beacon.owner_id!, () => {
        handleClose();
      })
    );
  }

  function handleBeaconDelete() {
    dispatch(
      RemoveBeacon(props.beacon.id, () => {
        handleClose();
      })
    );
  }

  function getDialogContent() {
    switch (props.action) {
      case "BAN":
        return "Banning this user will remove all their beacons and prevent them from adding more. Continue?";
      case "REMOVE":
        return "Removing this beacon will prevent it from showing in any views. This cannot be undone.";
    }
  }

  return (
    <Dialog open={props.open} onClose={handleClose}>
      <DialogTitle>Confirm Moderation Action</DialogTitle>
      <DialogContent>
        <DialogContentText>{getDialogContent()}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmModerationDialog;
